import * as React from "react"
import {
  Text,
  HStack,
  Box,
  Image,
} from "@chakra-ui/react"
import { brandConfig } from "./brandConfig"

// Main Logo component
export const Logo = React.forwardRef<HTMLDivElement, any>((props, ref) => {
  return (
    <HStack spacing={2} align="center" ref={ref} {...props}>
      <Box 
        display="inline-flex" 
        alignItems="center" 
        justifyContent="center"
        position="relative"
        transition="all 0.3s ease"
        _hover={{
          transform: "scale(1.05)",
        }}
      >
        <Image 
          src="/assets/onesolarimages/One-logo.png"
          alt="One Solar Australia"
          height="100px"
          width="auto"
          objectFit="contain"
        />
      </Box>
      <Text 
        fontSize={{ base: "lg", md: "xl" }}
        fontWeight="600" 
        color="white"
        letterSpacing="-0.02em"
        whiteSpace="nowrap"
        fontFamily="'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif"
      >
        {brandConfig.siteName}
      </Text>
    </HStack>
  )
})

Logo.displayName = 'Logo'

export default Logo;